import React, { useEffect, useState } from "react";
import { getThought } from "../Service/Api"; 
const Thought = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
   const fetchData = async () => {
     try {
       const data = await getThought();
       console.log(data)
       setData(data);
     } catch (error) {
       console.error("Error fetching online registration data:", error);
     }  
   };
   fetchData();
 }, []); 
  return (
    <>
    <div class="thought">
    <div className="container-fluid fulwidth">
        <div className="row">
           <div className="col-lg-12">
               <div className="maintitle">
                  <h1>Today's Thought</h1> 
               </div>
           </div>
           <div className="col-lg-12">
             {data.map((item)=>( 
                <p key={item.id}><div dangerouslySetInnerHTML={{ __html: item.message }} /></p>
             ))} 
           </div>
         </div>
    </div>
</div>
    </>
  )
}

export default Thought
